import { Helmet } from "react-helmet-async";

const SITE_NAME = "Bar Spot Ltd";
const SITE_URL = "https://www.barspotltd.co.uk";
const DEFAULT_IMAGE = "https://customer-assets.emergentagent.com/job_e827ccd5-2f27-4774-b667-e51a7471a3ba/artifacts/fdqtel6m_bARSPOT.jpg";

const SEO = ({ title, description, canonical, ogType = "website", schema }) => {
  const fullTitle = title;
  const fullCanonical = `${SITE_URL}${canonical || ""}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullCanonical} />

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={DEFAULT_IMAGE} />
      <meta property="og:locale" content="en_GB" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={DEFAULT_IMAGE} />

      {/* Geo targeting */}
      <meta name="geo.region" content="GB" />
      <meta name="geo.placename" content="Birmingham" />

      {/* Schema JSON-LD */}
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export default SEO;

// Shared LocalBusiness schema used across pages
export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://www.barspotltd.co.uk/#business",
  "name": "Bar Spot Ltd",
  "description": "Award-winning mobile bar hire for weddings, corporate events & festivals across the UK. Based in Birmingham and Cambridge.",
  "url": "https://www.barspotltd.co.uk",
  "telephone": "+447554856712",
  "email": "hello@barspotltd.co.uk",
  "image": "https://customer-assets.emergentagent.com/job_e827ccd5-2f27-4774-b667-e51a7471a3ba/artifacts/fdqtel6m_bARSPOT.jpg",
  "priceRange": "££",
  "currenciesAccepted": "GBP",
  "paymentAccepted": "Cash, Credit Card",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Unit A, 82 James Carter Road",
    "addressLocality": "Mildenhall",
    "addressRegion": "Suffolk",
    "postalCode": "IP28 7DE",
    "addressCountry": "GB"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 52.3446,
    "longitude": 0.5133
  },
  "areaServed": [
    { "@type": "City", "name": "Birmingham" },
    { "@type": "City", "name": "Cambridge" },
    { "@type": "AdministrativeArea", "name": "West Midlands" },
    { "@type": "AdministrativeArea", "name": "Worcestershire" },
    { "@type": "AdministrativeArea", "name": "Cambridgeshire" },
    { "@type": "AdministrativeArea", "name": "East Midlands" },
    { "@type": "AdministrativeArea", "name": "Warwickshire" },
    { "@type": "AdministrativeArea", "name": "Hertfordshire" },
    { "@type": "Country", "name": "United Kingdom" }
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "5.0",
    "bestRating": "5",
    "ratingCount": "18",
    "reviewCount": "18"
  },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    "opens": "09:00",
    "closes": "23:00"
  },
  "sameAs": [
    "https://facebook.com/Barspotuk",
    "https://instagram.com/Barspotuk",
    "https://www.linkedin.com/company/66876161"
  ]
};
